module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ho8EB"))).then(() => parcelRequire('hEqeo'));